import React from 'react';

import Card from './Card';

import Button from '../../common/Elements/Button/Button';
import Icon, { ICONS } from '../../common/Elements/Icon/Icon';
import { useConfirmDiscardChanges } from '../hooks';

const EditorLayout = ({
  title,
  isEditMode,
  toggleIsEditMode,
  onSave,
  isEditable,
  children,
}) => {
  const [DiscardChangesModal, confirmDiscardChanges] =
    useConfirmDiscardChanges();

  const handleClickCancel = async () => {
    if (!(await confirmDiscardChanges())) return;

    toggleIsEditMode();
  };

  return (
    <>
      <Card className="tw-h-full">
        <div className="tw-relative tw-px-[40px] tw-py-[20px] tw-border-b tw-border-cfo-grey-500">
          <h1 className="tw-text-center tw-text-[24px] tw-font-brandonTextMedium">
            {title}
          </h1>
          <div className="tw-absolute tw-bottom-[20%] tw-right-[40px]">
            {isEditMode && isEditable && (
              <div className="tw-flex tw-gap-[10px]">
                <Button
                  onClick={handleClickCancel}
                  buttonClassSettings={{ variant: 'inverse', size: 'md' }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={onSave}
                  buttonClassSettings={{ variant: 'secondary', size: 'md' }}
                >
                  Save Changes
                </Button>
              </div>
            )}
            {!isEditMode && isEditable && (
              <Button
                onClick={toggleIsEditMode}
                buttonClassSettings={{ variant: 'style_unset', size: 'md' }}
                className="tw-text-cfo-blue-600"
              >
                <Icon
                  icon={ICONS.edit}
                  className="tw-text-[18px] tw-mr-[5px]"
                />
                Edit
              </Button>
            )}
          </div>
        </div>
        <div className="tw-p-[40px] tw-grow tw-overflow-y-auto">{children}</div>
      </Card>
      <DiscardChangesModal />
    </>
  );
};

export default EditorLayout;
